<template>
  <b-card class="mb-3">
    <div class="d-flex justify-content-between mb-3" v-if="title">
      <h2 class="mb-0">Recent Meetings</h2>

      <b-btn variant="secondary" size="sm" to="/admin/meetings">
        View More
      </b-btn>
    </div>
    <div class="d-flex justify-content-end mx-2 mb-3">
      <b-btn variant="secondary" size="sm" @click="exportMeetings()">
        Export
      </b-btn>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th>Inviter</th>
          <th>Invitee</th>
          <th>Date</th>
          <th>Time</th>
          <th>Location</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="results.length === 0">
          <td class="text-center" colspan="7">
            <em>No meetings found!</em>
          </td>
        </tr>

        <tr v-for="meeting in results" :key="meeting.uuid">
          <td>
            <router-link :to="`/user/${meeting.inviter.uuid}`">
              <img
                class="rounded-circle img-profile mr-2"
                :src="meeting.inviter.avatar"
                :alt="`${meeting.inviter.first_name} ${meeting.inviter.last_name}`"
              >
              {{ meeting.inviter.first_name }} {{ meeting.inviter.last_name }}
            </router-link>
          </td>
          <td>
            <router-link :to="`/user/${meeting.invitee.uuid}`">
              <img
                class="rounded-circle img-profile mr-2"
                :src="meeting.invitee.avatar"
                :alt="`${meeting.invitee.first_name} ${meeting.invitee.last_name}`"
              >
              {{ meeting.invitee.first_name }} {{ meeting.invitee.last_name }}
            </router-link>
          </td>
          <td>{{ meeting.date }}</td>
          <td>{{ meeting.start_time }} to {{ meeting.end_time }}</td>
          <td>{{ meeting_types[ meeting.meeting_type ] }}</td>
          <td>
            <span :class="{
              'text-success': meeting.status === 'approved',
              'text-danger': meeting.status === 'declined',
              'text-info': meeting.status === 'pending'
            }">
              {{ meeting.status.charAt(0).toUpperCase() + meeting.status.substr(1) }}
            </span>
          </td>
          <td>
            <b-btn
              variant="danger" size="sm" block
              @click="deleteModel(meeting)"
            >
              Delete
            </b-btn>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="d-flex justify-content-between align-items-center" v-if="pagination">
      <b-btn
        variant="secondary" size="sm"
        @click="setPage(page - 1)" :disabled="loading || page === 1"
      >
        Prev Page
      </b-btn>

      <span class="text-muted" v-if="!loading">
        Page {{ page }} of {{ totalPages }}
      </span>

      <span class="text-muted" v-if="loading">
        Loading
      </span>

      <b-btn
        variant="secondary" size="sm"
        @click="setPage(page + 1)" :disabled="loading || page === totalPages"
      >
        Next Page
      </b-btn>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'MeetingsTable',
  props: {
    count: Number,
    pagination: Boolean,
    title: Boolean
  },
  data () {
    return {
      loading: false,
      page: 1,
      totalPages: 0,
      results: [],
      meeting_types: {
        'in-person': 'In Person',
        'remote': 'Remote',
      }
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true

      this.$http.get('/admin/meetings?page=' + this.page + '&page_count=' + this.count)
        .then(res => {
          this.results = res.data.data
          this.totalPages = res.data.meta.last_page
        })
        .finally(() => {
          this.loading = false
        })
    },
    setPage (page) {
      this.page = page
      this.load()
      window.scrollTo(0,0)
    },
    deleteModel (meeting) {
      if (!window.confirm('Are you sure you want to delete this meeting?')) {
        return
      }

      this.loading = true

      this.$http.delete(`/admin/meetings/${meeting.uuid}`)
        .then(() => {
          this.load()
        })
        .finally(() => {
          this.loading = false
        })
    },
    exportMeetings() {
      if (this.loading) {
        return
      }

      this.loading = true
      this.$http.post(`/admin/meetings/export`)
        .then(res => {
            var fileUrl = window.URL.createObjectURL(new Blob([res.data]))
            var fileLink = document.createElement('a')

            fileLink.href = fileUrl
            fileLink.setAttribute('download', 'meetings.csv')
            document.body.appendChild(fileLink)
            fileLink.click()
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.img-profile { width: 24px; height: 24px; }
</style>
